<template>
  <FlexLayout role="region">
    <BlockContainer>
      {{ $t('notification.SSOLoginError') }}
    </BlockContainer>
  </FlexLayout>
</template>

<script>
import FlexLayout from "@/components/layout-components/Main/FlexLayout.vue";
import BlockContainer from "@/components/layout/BlockContainer.vue";

export default {
  components: {BlockContainer, FlexLayout},
  computed: {
    config() {
      return window.config;
    },
  },
};
</script>

<style scoped>
</style>
